import ApolloClient from "apollo-client";

import { cache } from "./cache";
import { httpLink } from "./httpLink";

export const client = new ApolloClient({
  cache,
  link: httpLink
});
